/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class PutCustomerInformationViewModel {
    id: string | null;
    clientConfigurationId: string;
    orderId: string;
    firstName: string;
    lastName: string;
    companyName: string;
    address: string;
    countryCode: string;
    city: string;
    postalCode: string;
    emailAddress: string;
    phoneNumber: string;
    description: string;
}
